'use client'

import type { RegionalBrandCode } from '@/lib/seo/marketUrls'
import type { ResolveDisplayCurrencyArgs } from '@/lib/currency/resolveDisplayCurrency'
import { useStorefrontMarket } from '@/useStorefrontMarket'

type UseStorefrontDisplayCurrencyArgs = Omit<
  ResolveDisplayCurrencyArgs,
  'host' | 'hostBrand' | 'fallbackBrand'
> & {
  fallbackBrand?: RegionalBrandCode | string | null
}

export const useStorefrontDisplayCurrency = (
  args: UseStorefrontDisplayCurrencyArgs = {}
) => {
  const market = useStorefrontMarket(args)

  return {
    currencyCode: market.currencyCode,
    currencySymbol: market.currencySymbol,
    storefrontBrand: market.brandCode,
  }
}
